export default "__VITE_ASSET__CuCzNpBF__"